import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Calculator, Package, MapPin, ArrowRight, ChevronDown, Clock, Ruler, Box, Info, Truck, Home, Store, AlertTriangle, Phone, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

// Marge ISMParcel par colis
const ISMPARCEL_MARGIN = 15;

// Tarifs OFFICIELS 2026 - Sources: laposte.fr, chronopost.fr
const SHIPPING_ZONES = {
  'DOM-TOM (Guadeloupe, Martinique, Réunion, Guyane, Mayotte)': {
    colissimoOptions: [
      {
        id: 'eco-om',
        name: 'Colissimo Éco',
        carrier: 'La Poste',
        icon: Truck,
        description: 'Économique, délai plus long',
        deliveryTime: '13-31 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 8.41 },
          { maxKg: 1, price: 11.73 },
          { maxKg: 2, price: 14.77 },
          { maxKg: 5, price: 24.80 },
          { maxKg: 10, price: 39.24 },
          { maxKg: 15, price: 79.42 },
          { maxKg: 30, price: 91.53 },
        ],
      },
      {
        id: 'standard-om',
        name: 'Colissimo Standard',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '6-18 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 12.02 },
          { maxKg: 1, price: 19.00 },
          { maxKg: 2, price: 25.89 },
          { maxKg: 5, price: 38.90 },
          { maxKg: 10, price: 62.32 },
          { maxKg: 15, price: 130.20 },
          { maxKg: 30, price: 143.02 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'chrono-om',
        name: 'Chronopost Express',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Livraison express rapide',
        deliveryTime: '2-5 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 66.00 },
          { maxKg: 2, price: 81.00 },
          { maxKg: 5, price: 99.00 },
          { maxKg: 10, price: 135.00 },
          { maxKg: 20, price: 185.00 },
          { maxKg: 30, price: 250.00 },
        ],
      },
    ],
    maxWeight: 30,
    maxDimensionSum: 150
  },
  'Polynésie française, Nouvelle-Calédonie, Wallis-et-Futuna': {
    colissimoOptions: [
      {
        id: 'eco-om2',
        name: 'Colissimo Éco',
        carrier: 'La Poste',
        icon: Truck,
        description: 'Économique, délai plus long',
        deliveryTime: '15-30 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 12.80 },
          { maxKg: 1, price: 17.90 },
          { maxKg: 2, price: 24.60 },
          { maxKg: 3, price: 31.30 },
          { maxKg: 5, price: 44.70 },
          { maxKg: 7, price: 58.10 },
          { maxKg: 10, price: 78.40 },
          { maxKg: 15, price: 112.30 },
          { maxKg: 20, price: 146.20 },
          { maxKg: 30, price: 195.00 },
        ],
      },
      {
        id: 'standard-om2',
        name: 'Colissimo Standard',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '8-15 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 18.50 },
          { maxKg: 1, price: 26.70 },
          { maxKg: 2, price: 38.90 },
          { maxKg: 3, price: 49.20 },
          { maxKg: 5, price: 67.80 },
          { maxKg: 7, price: 86.40 },
          { maxKg: 10, price: 114.60 },
          { maxKg: 15, price: 162.30 },
          { maxKg: 20, price: 210.00 },
          { maxKg: 30, price: 285.00 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'chrono-om2',
        name: 'Chronopost Express',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Livraison express rapide',
        deliveryTime: '3-6 jours',
        isExpress: true,
        rates: [
          { maxKg: 0.5, price: 68.00 },
          { maxKg: 1, price: 85.00 },
          { maxKg: 2, price: 108.00 },
          { maxKg: 3, price: 125.00 },
          { maxKg: 5, price: 155.00 },
          { maxKg: 7, price: 182.00 },
          { maxKg: 10, price: 225.00 },
          { maxKg: 15, price: 295.00 },
          { maxKg: 20, price: 360.00 },
          { maxKg: 30, price: 470.00 },
        ],
      },
    ],
    maxWeight: 30,
    maxDimensionSum: 150
  },
  'Europe (UE, Suisse, Andorre)': {
    colissimoOptions: [
      {
        id: 'relais-eu',
        name: 'Colissimo Point Retrait',
        carrier: 'La Poste',
        icon: Store,
        description: 'Retrait en point relais',
        deliveryTime: '3-6 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 12.49 },
          { maxKg: 1, price: 16.89 },
          { maxKg: 2, price: 19.69 },
          { maxKg: 5, price: 26.09 },
          { maxKg: 10, price: 44.49 },
          { maxKg: 15, price: 65.49 },
          { maxKg: 20, price: 85.49 },
        ],
      },
      {
        id: 'standard-eu',
        name: 'Colissimo Domicile',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '3-5 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 14.99 },
          { maxKg: 1, price: 19.39 },
          { maxKg: 2, price: 22.19 },
          { maxKg: 5, price: 28.59 },
          { maxKg: 10, price: 46.99 },
          { maxKg: 15, price: 67.99 },
          { maxKg: 20, price: 87.99 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'gls-eu',
        name: 'GLS Express',
        carrier: 'GLS',
        icon: Truck,
        description: 'Transport européen rapide',
        deliveryTime: '1-3 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 15.90 },
          { maxKg: 2, price: 17.90 },
          { maxKg: 5, price: 22.90 },
          { maxKg: 10, price: 29.90 },
          { maxKg: 20, price: 39.90 },
          { maxKg: 31.5, price: 54.90 },
        ],
      },
      {
        id: 'chrono-eu',
        name: 'Chronopost Classic',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Express avec suivi',
        deliveryTime: '1-2 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 51.00 },
          { maxKg: 2, price: 61.00 },
          { maxKg: 5, price: 72.00 },
          { maxKg: 10, price: 95.00 },
          { maxKg: 20, price: 130.00 },
          { maxKg: 30, price: 175.00 },
        ],
      },
    ],
    maxWeight: 31.5,
    maxDimensionSum: 150
  },
  'Royaume-Uni': {
    colissimoOptions: [
      {
        id: 'standard-uk',
        name: 'Colissimo International',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '4-7 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 18.99 },
          { maxKg: 1, price: 23.39 },
          { maxKg: 2, price: 26.19 },
          { maxKg: 5, price: 32.59 },
          { maxKg: 10, price: 50.99 },
          { maxKg: 15, price: 71.99 },
          { maxKg: 20, price: 91.99 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'chrono-uk',
        name: 'Chronopost Express',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Express vers UK',
        deliveryTime: '2-3 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 51.00 },
          { maxKg: 2, price: 61.00 },
          { maxKg: 5, price: 72.00 },
          { maxKg: 10, price: 95.00 },
          { maxKg: 20, price: 130.00 },
          { maxKg: 30, price: 175.00 },
        ],
      },
    ],
    maxWeight: 30,
    maxDimensionSum: 150
  },
  'Afrique du Nord (Maroc, Algérie, Tunisie)': {
    colissimoOptions: [
      {
        id: 'standard-afn',
        name: 'Colissimo International',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '7-14 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 23.79 },
          { maxKg: 1, price: 28.39 },
          { maxKg: 2, price: 31.09 },
          { maxKg: 5, price: 39.89 },
          { maxKg: 10, price: 66.09 },
          { maxKg: 15, price: 89.59 },
          { maxKg: 20, price: 109.49 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'chrono-afn',
        name: 'Chronopost Express',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Express Afrique du Nord',
        deliveryTime: '3-5 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 56.00 },
          { maxKg: 2, price: 67.00 },
          { maxKg: 5, price: 85.00 },
          { maxKg: 10, price: 120.00 },
          { maxKg: 20, price: 175.00 },
          { maxKg: 30, price: 240.00 },
        ],
      },
    ],
    maxWeight: 30,
    maxDimensionSum: 150
  },
  'Afrique (Sénégal, Côte d\'Ivoire, Cameroun, Mali...)': {
    colissimoOptions: [
      {
        id: 'standard-afr',
        name: 'Colissimo International',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '10-21 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 35.19 },
          { maxKg: 1, price: 39.19 },
          { maxKg: 2, price: 53.99 },
          { maxKg: 5, price: 78.69 },
          { maxKg: 10, price: 148.99 },
          { maxKg: 15, price: 210.79 },
          { maxKg: 20, price: 256.89 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'chrono-afr',
        name: 'Chronopost Express',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Express vers l\'Afrique',
        deliveryTime: '3-6 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 80.00 },
          { maxKg: 2, price: 95.00 },
          { maxKg: 5, price: 130.00 },
          { maxKg: 10, price: 185.00 },
          { maxKg: 20, price: 280.00 },
          { maxKg: 30, price: 380.00 },
        ],
      },
    ],
    maxWeight: 30,
    maxDimensionSum: 150
  },
  'Asie & Reste du monde': {
    colissimoOptions: [
      {
        id: 'standard-world',
        name: 'Colissimo International',
        carrier: 'La Poste',
        icon: Home,
        description: 'Livraison à domicile',
        deliveryTime: '10-21 jours',
        isExpress: false,
        rates: [
          { maxKg: 0.5, price: 35.19 },
          { maxKg: 1, price: 39.19 },
          { maxKg: 2, price: 53.99 },
          { maxKg: 5, price: 78.69 },
          { maxKg: 10, price: 148.99 },
          { maxKg: 15, price: 210.79 },
          { maxKg: 20, price: 256.89 },
        ],
      },
    ],
    expressOptions: [
      {
        id: 'chrono-world',
        name: 'Chronopost Express',
        carrier: 'Chronopost',
        icon: Zap,
        description: 'Express mondial',
        deliveryTime: '3-6 jours',
        isExpress: true,
        rates: [
          { maxKg: 1, price: 80.00 },
          { maxKg: 2, price: 95.00 },
          { maxKg: 5, price: 130.00 },
          { maxKg: 10, price: 185.00 },
          { maxKg: 20, price: 280.00 },
          { maxKg: 30, price: 380.00 },
        ],
      },
    ],
    maxWeight: 30,
    maxDimensionSum: 150
  },
};

// Catégories de taille
const SIZE_CATEGORIES = [
  {
    id: 'small',
    name: 'Petit',
    icon: '📦',
    dimensions: '< 50 cm',
    examples: ['Vêtements, Téléphone, Livres'],
    defaultDimensions: { length: 25, width: 15, height: 8 },
    maxDimensionSum: 50,
  },
  {
    id: 'medium',
    name: 'Moyen',
    icon: '📫',
    dimensions: '50-100 cm',
    examples: ['Chaussures, Sac, Petit électro'],
    defaultDimensions: { length: 40, width: 30, height: 20 },
    maxDimensionSum: 100,
  },
  {
    id: 'large',
    name: 'Grand',
    icon: '🗃️',
    dimensions: '100-150 cm',
    examples: ['Ordinateur, Valise, Robot'],
    defaultDimensions: { length: 60, width: 45, height: 35 },
    maxDimensionSum: 150,
  },
];

const COLISSIMO_MAX_DIMENSION_SUM = 150;
const COLISSIMO_MAX_LENGTH = 100;

export default function PriceCalculatorAdvanced() {
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [weight, setWeight] = useState('');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [calculatedResults, setCalculatedResults] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showDimensions, setShowDimensions] = useState(false);

  useEffect(() => {
    if (length && width && height) {
      const sum = parseFloat(length) + parseFloat(width) + parseFloat(height);
      const category = SIZE_CATEGORIES.find((cat, index) => {
        const prevMax = index === 0 ? 0 : SIZE_CATEGORIES[index - 1].maxDimensionSum;
        return sum > prevMax && sum <= cat.maxDimensionSum;
      });
      setSelectedCategory(category || null);
    }
  }, [length, width, height]);

  useEffect(() => {
    setSelectedOption(null);
    setCalculatedResults(null);
  }, [selectedZone]);

  const calculatePrice = (option, weightNum) => {
    for (const rate of option.rates) {
      if (weightNum <= rate.maxKg) {
        // Return base transport price only (without margin)
        return rate.price;
      }
    }
    const lastPrice = option.rates[option.rates.length - 1]?.price || 0;
    return lastPrice;
  };

  const calculateAllPrices = () => {
    if (!selectedZone || !weight) return;
    
    const zoneData = SHIPPING_ZONES[selectedZone];
    if (!zoneData) return;

    const weightNum = parseFloat(weight);
    const lengthNum = parseFloat(length) || 0;
    const widthNum = parseFloat(width) || 0;
    const heightNum = parseFloat(height) || 0;
    const dimensionSum = lengthNum + widthNum + heightNum;
    
    // Vérifier dimensions
    if (dimensionSum > 0 && dimensionSum > COLISSIMO_MAX_DIMENSION_SUM) {
      setCalculatedResults({ 
        error: 'oversized', 
        reason: 'dimensions',
        value: dimensionSum,
        max: COLISSIMO_MAX_DIMENSION_SUM
      });
      return;
    }

    if (lengthNum > COLISSIMO_MAX_LENGTH) {
      setCalculatedResults({ 
        error: 'oversized', 
        reason: 'length',
        value: lengthNum,
        max: COLISSIMO_MAX_LENGTH
      });
      return;
    }

    // Calculer tous les prix (Colissimo + Express)
    let allOptions = [];

    // Options Colissimo
    zoneData.colissimoOptions.forEach(option => {
      const maxWeight = option.rates[option.rates.length - 1].maxKg;
      if (weightNum <= maxWeight) {
        const price = calculatePrice(option, weightNum);
        if (price) {
          allOptions.push({ ...option, calculatedPrice: price });
        }
      }
    });

    // Options Express (Chronopost, GLS)
    zoneData.expressOptions.forEach(option => {
      const maxWeight = option.rates[option.rates.length - 1].maxKg;
      if (weightNum <= maxWeight) {
        const price = calculatePrice(option, weightNum);
        if (price) {
          allOptions.push({ ...option, calculatedPrice: price });
        }
      }
    });

    if (allOptions.length === 0) {
      setCalculatedResults({ 
        error: 'oversized', 
        reason: 'weight',
        value: weightNum,
        max: zoneData.maxWeight
      });
      return;
    }

    // Trier par prix
    allOptions.sort((a, b) => a.calculatedPrice - b.calculatedPrice);

    // Sélectionner les meilleures options :
    // - Les 2 moins chères (souvent Colissimo)
    // - + 1 option express si pas déjà incluse
    let finalOptions = [];
    let hasExpress = false;

    for (const opt of allOptions) {
      if (finalOptions.length < 2) {
        finalOptions.push(opt);
        if (opt.isExpress) hasExpress = true;
      } else if (!hasExpress && opt.isExpress) {
        finalOptions.push(opt);
        hasExpress = true;
        break;
      }
    }

    // Si on n'a pas trouvé d'express dans le top, ajouter le moins cher express
    if (!hasExpress) {
      const cheapestExpress = allOptions.find(o => o.isExpress);
      if (cheapestExpress) {
        finalOptions.push(cheapestExpress);
      }
    }

    setCalculatedResults({ 
      options: finalOptions,
      weight: weightNum, 
      zone: selectedZone,
    });
  };

  const handleNumberInput = (setter) => (e) => {
    const value = e.target.value;
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setter(value);
      setCalculatedResults(null);
    }
  };

  const selectSizeCategory = (category) => {
    setLength(String(category.defaultDimensions.length));
    setWidth(String(category.defaultDimensions.width));
    setHeight(String(category.defaultDimensions.height));
    setShowDimensions(true);
    setSelectedCategory(category);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  };

  const getCarrierBadge = (carrier, isExpress) => {
    if (isExpress) {
      return { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Express' };
    }
    const badges = {
      'La Poste': { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'La Poste' },
      'Chronopost': { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Chronopost' },
      'GLS': { bg: 'bg-green-100', text: 'text-green-700', label: 'GLS' },
    };
    return badges[carrier] || { bg: 'bg-slate-100', text: 'text-slate-700', label: carrier };
  };

  return (
    <Card className="bg-white border-2 border-blue-200 shadow-xl rounded-2xl overflow-hidden" data-testid="price-calculator">
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
        <div className="flex items-center gap-3 text-white">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
            <Calculator className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-heading font-bold text-xl">Calculateur de prix</h3>
            <p className="text-blue-100 text-sm">Comparez les meilleures options</p>
          </div>
        </div>
      </div>
      
      <CardContent className="p-5">
        <div className="space-y-4">
          {/* Taille */}
          <div className="space-y-2">
            <Label className="text-slate-700 font-medium flex items-center gap-2 text-sm">
              <Box className="w-4 h-4 text-blue-600" />
              Taille du colis
            </Label>
            <div className="grid grid-cols-3 gap-2">
              {SIZE_CATEGORIES.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => selectSizeCategory(cat)}
                  className={`p-2.5 rounded-lg border-2 text-center transition-all hover:shadow-md ${
                    selectedCategory?.id === cat.id 
                      ? 'border-blue-500 bg-blue-50' 
                      : 'border-slate-200 hover:border-slate-300'
                  }`}
                  data-testid={`size-${cat.id}`}
                >
                  <span className="text-xl block">{cat.icon}</span>
                  <span className="font-medium text-xs text-slate-800 block">{cat.name}</span>
                  <span className="text-[10px] text-slate-500 block">{cat.dimensions}</span>
                </button>
              ))}
            </div>
            {selectedCategory && (
              <p className="text-xs text-slate-500 bg-slate-50 p-2 rounded">
                {selectedCategory.examples}
              </p>
            )}
          </div>

          {/* Dimensions */}
          <div className="space-y-2">
            <button 
              onClick={() => setShowDimensions(!showDimensions)}
              className="flex items-center gap-2 text-xs text-blue-600 hover:text-blue-700 font-medium"
            >
              <Ruler className="w-3 h-3" />
              {showDimensions ? 'Masquer' : 'Préciser'} les dimensions
              <ChevronDown className={`w-3 h-3 transition-transform ${showDimensions ? 'rotate-180' : ''}`} />
            </button>
            
            {showDimensions && (
              <div className="grid grid-cols-3 gap-2">
                <div>
                  <Label className="text-[10px] text-slate-500">Longueur (cm)</Label>
                  <Input type="text" inputMode="decimal" placeholder="L" value={length}
                    onChange={handleNumberInput(setLength)} className="h-9 text-sm" />
                </div>
                <div>
                  <Label className="text-[10px] text-slate-500">Largeur (cm)</Label>
                  <Input type="text" inputMode="decimal" placeholder="l" value={width}
                    onChange={handleNumberInput(setWidth)} className="h-9 text-sm" />
                </div>
                <div>
                  <Label className="text-[10px] text-slate-500">Hauteur (cm)</Label>
                  <Input type="text" inputMode="decimal" placeholder="h" value={height}
                    onChange={handleNumberInput(setHeight)} className="h-9 text-sm" />
                </div>
              </div>
            )}
            
            {showDimensions && length && width && height && (
              <p className="text-[10px] text-slate-500 flex items-center gap-1">
                <Info className="w-3 h-3" />
                Total : {(parseFloat(length) + parseFloat(width) + parseFloat(height)).toFixed(0)} cm 
                <span className="text-slate-400">(max 150 cm)</span>
              </p>
            )}
          </div>

          {/* Destination */}
          <div className="space-y-2">
            <Label className="text-slate-700 font-medium flex items-center gap-2 text-sm">
              <MapPin className="w-4 h-4 text-blue-600" />
              Destination
            </Label>
            <div className="relative">
              <select
                value={selectedZone}
                onChange={(e) => setSelectedZone(e.target.value)}
                className="w-full h-11 px-4 pr-10 bg-white border border-slate-200 rounded-lg text-slate-900 appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                data-testid="zone-select"
              >
                <option value="">Choisir une destination</option>
                {Object.keys(SHIPPING_ZONES).map((zone) => (
                  <option key={zone} value={zone}>{zone}</option>
                ))}
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 pointer-events-none" />
            </div>
          </div>

          {/* Poids */}
          <div className="space-y-2">
            <Label className="text-slate-700 font-medium flex items-center gap-2 text-sm">
              <Package className="w-4 h-4 text-blue-600" />
              Poids (kg)
            </Label>
            <Input
              type="text"
              inputMode="decimal"
              placeholder="Ex: 2.5"
              value={weight}
              onChange={handleNumberInput(setWeight)}
              className="h-11"
              data-testid="weight-input"
            />
          </div>

          {/* Bouton */}
          <Button 
            onClick={calculateAllPrices}
            disabled={!selectedZone || !weight}
            className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white font-bold"
            data-testid="calculate-btn"
          >
            Comparer les prix
          </Button>

          {/* Résultats */}
          {calculatedResults && !calculatedResults.error && (
            <div className="mt-4 space-y-3">
              <p className="text-sm text-slate-600 font-medium text-center">
                Meilleures options pour {calculatedResults.weight} kg
              </p>
              
              {calculatedResults.options.map((option, index) => {
                const badge = getCarrierBadge(option.carrier, option.isExpress);
                return (
                  <div 
                    key={option.id}
                    onClick={() => setSelectedOption(option)}
                    className={`p-4 rounded-xl border-2 cursor-pointer transition-all relative ${
                      selectedOption?.id === option.id 
                        ? 'border-green-500 bg-green-50' 
                        : 'border-slate-200 hover:border-blue-300 bg-white'
                    }`}
                  >
                    {index === 0 && (
                      <span className="absolute -top-2 right-3 bg-green-600 text-white text-[9px] px-2 py-0.5 rounded-full font-medium">
                        Meilleur prix
                      </span>
                    )}
                    {option.isExpress && index !== 0 && (
                      <span className="absolute -top-2 right-3 bg-orange-500 text-white text-[9px] px-2 py-0.5 rounded-full font-medium">
                        Express
                      </span>
                    )}
                    
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          option.isExpress ? 'bg-orange-100' : 'bg-slate-100'
                        }`}>
                          <option.icon className={`w-5 h-5 ${
                            option.isExpress ? 'text-orange-600' : 'text-slate-600'
                          }`} />
                        </div>
                        <div>
                          <div className="flex items-center gap-2">
                            <p className="font-semibold text-slate-800 text-sm">{option.name}</p>
                            <span className={`text-[9px] px-1.5 py-0.5 rounded font-medium ${badge.bg} ${badge.text}`}>
                              {badge.label}
                            </span>
                          </div>
                          <p className="text-[11px] text-slate-500">{option.description}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className={`font-bold text-xl ${
                          selectedOption?.id === option.id ? 'text-green-600' : 'text-blue-600'
                        }`}>
                          {formatCurrency(option.calculatedPrice)}
                        </p>
                        <div className="flex items-center gap-1 justify-end">
                          <Clock className="w-3 h-3 text-slate-400" />
                          <p className="text-[11px] text-slate-500">{option.deliveryTime}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              
              {/* Frais de gestion */}
              <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-sm font-medium text-blue-800">
                  + 15€ de frais de gestion
                </p>
                <p className="text-xs text-blue-600 mt-1">
                  Ce sont les seuls frais appliqués. Pour les frais de douane (si applicables), 
                  ils sont à la charge du destinataire. Nous ne prenons aucune marge dessus.
                </p>
              </div>
              
              {selectedOption && (
                <Link to="/register" className="block">
                  <Button className="w-full mt-3 bg-green-600 hover:bg-green-700 text-white font-bold h-11">
                    Créer mon compte
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              )}
            </div>
          )}

          {/* Erreur colis hors normes */}
          {calculatedResults?.error === 'oversized' && (
            <div className="mt-4 p-4 rounded-xl bg-amber-50 border border-amber-200">
              <div className="flex items-start gap-3">
                <AlertTriangle className="w-6 h-6 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-amber-800">Colis hors limites</p>
                  <p className="text-sm text-amber-700 mt-1">
                    {calculatedResults.reason === 'weight' && `Poids ${calculatedResults.value} kg (max ${calculatedResults.max} kg)`}
                    {calculatedResults.reason === 'dimensions' && `Dimensions ${calculatedResults.value} cm (max ${calculatedResults.max} cm)`}
                    {calculatedResults.reason === 'length' && `Longueur ${calculatedResults.value} cm (max ${calculatedResults.max} cm)`}
                  </p>
                  <p className="text-sm text-slate-600 mt-2">
                    Contactez-nous pour un <strong>devis personnalisé</strong>.
                  </p>
                  <a href="tel:+33695148686"
                    className="inline-flex items-center gap-2 mt-3 px-4 py-2 bg-amber-600 text-white rounded-lg text-sm font-medium hover:bg-amber-700">
                    <Phone className="w-4 h-4" />
                    06 95 14 86 86
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
        
        <div className="mt-5 pt-4 border-t border-slate-200">
          <p className="text-[10px] text-slate-400 text-center">
            Colissimo • Chronopost • GLS | Tarifs indicatifs 2026
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
